import { render, staticRenderFns } from "./IncidentDetailsModal.vue?vue&type=template&id=55f25c7f&"
import script from "./IncidentDetailsModal.vue?vue&type=script&lang=js&"
export * from "./IncidentDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports